export enum WAFPayloadLimitActionEnum {
  Block,
  Log,
  Ignore,
}
